import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useAvailableHeight from "../../Custom/UseAvailableHeight";
import { Avatar, Button, Typography, FormControlLabel, Checkbox } from '@mui/material';
import useApi from '../../Utilities/useAPI';
import CryptoJS from 'crypto-js';
// import frame from "../../../Assets/img/upload-image.png";
import { useUserDetailContext } from '../../UserDetailContext';
import { ReactComponent as ConsentIndication } from "../../../Assets/img/icons/consent_indication.svg"
import { ReactComponent as VerifiedTickN } from "../../../Assets/img/icons/Verified-icon-new.svg";
import { ReactComponent as NonVerifiedTickNew } from "../../../Assets/img/icons/Non-verified-icon.svg";
import DefaultProfileBg from "../../../Assets/img/card/profilebg.png"

const UserDetailGlobalSearch = () => {
    const [availableHeight1, Column1Ref] = useAvailableHeight(172);
    const objectId = localStorage.getItem("objectId");
    const { callApiFunction } = useApi();
    const [profileData, setProfileData] = useState(null);
    const { encryptedId } = useParams();
    const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedId), 'UserDetailsSecretKey');
    const id = bytes.toString(CryptoJS.enc.Utf8);

    const [cardsWithAccess, setCardsWithAccess] = useState([]);
    const [selectedCards, setSelectedCards] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const { userDetails } = useUserDetailContext();
    const [userCardToken, setuserCardToken] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await callApiFunction('userDetailedView', {
                    referenceId: id
                });

                setuserCardToken(response.token);

                if (response.status === "SUCCESS") {
                    setProfileData(response.data);
                    
                    // Extract card names from the array of card objects
                    const cardNames = response.data.card_names.map(card => card.card_name || card.card_type);
                
                    const checkAccessResponse = await callApiFunction('fetchCardAccesssDetails', {
                        ownerId: id,
                        viewerToken: objectId,
                        cardNames: cardNames // Pass card names in array format
                    });
                
                    if (checkAccessResponse.statusCode === 200) {
                        const accessibleCards = checkAccessResponse.accessResults
                            .filter(card => card.access)
                            .map(card => card.cardName);
                
                        setCardsWithAccess(accessibleCards);
                    }
                }
            } catch (error) {
                console.log('Error:', error);
            }
        };

        fetchData();
    }, [id]);

    const handleSelectAll = () => {
        const newSelectAll = !selectAll;
        setSelectAll(newSelectAll);
    
        if (newSelectAll) {
            // Select all non-accessible cards
            const nonAccessibleCards = profileData?.card_names
                ?.filter(card => !cardsWithAccess.includes(card.card_name || card.card_type))
                ?.map(card => card.card_name || card.card_type);
    
            setSelectedCards(nonAccessibleCards);
        } else {
            setSelectedCards([]);
        }
    };
    
    const handleCardSelect = (index, card) => {
        const updatedCards = [...selectedCards];

        if (updatedCards.includes(card)) {
            setSelectedCards(updatedCards.filter(selectedCard => selectedCard !== card));
        } else {
            setSelectedCards([...updatedCards, card]);
        }
    };

    const handleSentConsent = async () => {
        const payload = {
            ownerId: id,
            cardNames: selectedCards,
            viewerToken: objectId,
        };

        try {
            const response = await callApiFunction('requestCardConsent', payload);
            setSelectedCards([]);
        }
        catch (error) {
            console.log('Error:', error);
        }
    }

    if (!profileData) {
        return <div>Loading...</div>;
    }

    return (
        <div className="professional-card-view">
            <div className='card_consent_page_left d-flex my-3 mx-3 w-100' style={{ backgroundColor: "#ffff", overflow: "hidden" }}>
                <div className='card_consent_page_left my-3 mx-3' ref={Column1Ref} style={{ width: "280px", minWidth: "280px", maxHeight: `${availableHeight1}px`, minHeight: `${availableHeight1}px`, overflowY: "auto", scrollbarWidth: "none" }}>
                    <div className='flex-center mt-5' style={{ position: "relative" }}>
                        <Avatar
                            src={profileData.user_profile_url}
                            alt={`${profileData.first_name} ${profileData.last_name} Avatar`}
                            style={{ width: '146px', height: '146px', marginBottom: '10px' }}
                        />
                        {profileData.is_verified ? (
                            <div className="verifiedcontainer flex-center">
                                <div className="me-3">Verified</div>
                                <div className="icon-verify-symbol flex-center">
                                    <VerifiedTickN />
                                </div>
                            </div>
                        ) :
                            <div className="verifiedcontainer flex-center" style={{ backgroundColor: "#EB4E3D", width: "106px" }}>
                                <div className="me-3">Unverified</div>
                                <div className="icon-verify-symbol flex-center">
                                    <NonVerifiedTickNew />
                                </div>
                            </div>}
                    </div>
                    <div className='flex-center flex-column mt-3'>
                        <h5 className='text-center fw-bold m-0'>{`${profileData.first_name} ${profileData.last_name}`}</h5>
                        <h5 className='text-center' style={{ fontSize: "18px", color: "#202224", margin: "12px 0px" }}>UID: {profileData.unique_id}</h5>
                        <h6 className='text-center mb-2' style={{ fontSize: "18px", fontWeight: "400" }}>{profileData.designation || profileData.field_of_study || profileData.title || '---'}</h6>
                        <Typography variant="body2" color="textSecondary" sx={{ fontSize: "16px", textAlign: "center" }}>{profileData.profession_department || profileData.institute || profileData.nickname || '---'}</Typography>
                    </div>
                </div>

                <div className='card_consent_page_left my-3 me-3' style={{ flexGrow: 1, maxHeight: `${availableHeight1}px`, minHeight: `${availableHeight1}px`, overflowY: "auto", scrollbarWidth: "none" }}>
                    <div className="d-flex w-100 align-items-center justify-content-between px-4 pt-4 pb-3">
                        <Typography variant="h6" color="textSecondary" style={{ fontSize: "18px" }}>Cards</Typography>
                        <div className="sub-heading-style-14">
                            <FormControlLabel
                                control={<Checkbox checked={selectAll} onChange={handleSelectAll} />}
                                label="Select All"
                                className="ms-1"
                            />
                        </div>
                    </div>

                    <div className="OverflowX ms-4 d-flex align-items-center" style={{ height: "254px", width: "99%", scrollbarWidth: "thin" }}>
                        {profileData?.card_names?.map((card, index) => {

                           if (card.card_type === "group_family") return null;
                            const isAccessible = cardsWithAccess.includes(card.card_name);
                            return (
                                <div key={index} className={`item-card-display me-3 ms-1 digi-card-new Smaller-screen`}>
                                    <a href={`/digital-identity/${card.card_name||card.card_type}/${userCardToken}`} target="_blank" rel="noopener noreferrer">
                                        <div className={`digi-card-upper-allcards Smaller-screen`}
                                            style={{ width: "176px", backgroundImage: `url(${card.profile_pic || DefaultProfileBg})` }}>

                                            {/* Show checkbox only for non-accessible cards */}
                                            {!isAccessible && (
                                                <div className="select_button_topRight" onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleCardSelect(index, card.card_name);
                                                }}>
                                                    <Checkbox
                                                        checked={selectedCards.includes(card.card_name||card.card_type)}
                                                        className="group-checkbox p-0"
                                                    />
                                                </div>
                                            )}

                                            <div className={`digi-card-label-container Smaller-screen`}>
                                                <span className='digi-card-label'>{card.card_name||card.card_type}</span>
                                            </div>
                                            <div>
                                                <svg className='wave-separator' preserveAspectRatio="xMinYMax meet" viewBox="0 0 366 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill="#ffff" d="M0 58V25.4141C14.0576 21.1915 19.0782 18.899 29.6214 16.4243L82.3374 9L131.037 14.4444L180.741 28.303L235.967 44.1414L267.095 48.101L299.226 46.6161L328.346 40.6767L345.918 34.7373L359.975 28.7979L366 25.8282V58H0Z" />
                                                    <path fill="#0044c6" fillRule="evenodd" clipRule="evenodd" d="M270.835 37.8259C297.482 38.5583 329.446 33.0627 365.999 15.174L365.999 26.0725C328.089 44.6257 299.049 49.5039 270.55 48.7205C242.18 47.9407 216.909 40.4361 191.422 32.5503C190.216 32.1771 189.008 31.8027 187.799 31.4277C138.042 16.0019 85.2863 -0.353631 0.502197 25.2657C76.7857 -18.7623 140.591 5.40451 190.828 20.9803C192.054 21.3604 193.277 21.7396 194.498 22.1172C220.042 30.0208 244.06 37.0899 270.835 37.8259Z" />
                                                </svg>
                                                {isAccessible &&
                                                    <div className={`company-logo-container-cardSection flex-center  Smaller-screen`} style={{ width: "34px", height: "34px" }}>
                                                        <ConsentIndication />
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        <div className={`p-2 digi-card-lower default-card Smaller-screen`}>
                                            <h2 className='Name' style={{ fontSize: "18px" }}>{profileData.first_name} {profileData.last_name}</h2>
                                            <span className='Profession d-block'>{card.card_type}</span>
                                        </div>
                                    </a>
                                </div>
                            );
                        })}
                    </div>

                    <div className='ms-4 mt-4'>*Send request for consent to view the card.</div>
                    <div className='w-100 flex-center my-4'>
                        <Button variant='contained' onClick={handleSentConsent} sx={{ backgroundColor: "#0044C6" }} disabled={selectedCards.length < 1}>CONSENT</Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserDetailGlobalSearch;